// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onehealth-intro {
  --oh-ink: #1b2a32;
  --oh-muted: #4a5d66;
  --oh-line: rgba(27, 42, 50, 0.1);
  --oh-wash: linear-gradient(165deg, #f4fbf8 0%, #eef6fb 52%, #f7f3ee 100%);
  --oh-physical: #c45c3a;
  --oh-mental: #5b4db3;
  --oh-social: #1d8a78;
  text-align: left;
  border-radius: 16px;
  padding: 0.95rem 1rem 1rem;
  background: var(--oh-wash);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.7) inset,
    0 10px 24px -12px rgba(27, 42, 50, 0.16);
  border: 1px solid rgba(29, 138, 120, 0.14);
  animation: onehealth-intro-in 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}

@keyframes onehealth-intro-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .onehealth-intro {
    animation: none;
  }
}

.onehealth-intro--dark {
  --oh-ink: #f4f7f8;
  --oh-muted: rgba(226, 232, 240, 0.82);
  --oh-line: rgba(255, 255, 255, 0.1);
  --oh-wash: linear-gradient(165deg, rgba(29, 138, 120, 0.18) 0%, rgba(91, 77, 179, 0.12) 100%);
  background: var(--oh-wash);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: none;
}

.onehealth-intro__eyebrow {
  margin: 0 0 0.28rem;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--oh-social);
}

.onehealth-intro--dark .onehealth-intro__eyebrow {
  color: #7ee0ce;
}

.onehealth-intro__title {
  margin: 0 0 0.45rem;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--oh-ink);
}

.onehealth-intro__body,
.onehealth-intro__align,
.onehealth-intro__smarttt {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.45;
}

.onehealth-intro__body {
  margin-bottom: 0.7rem;
  color: var(--oh-muted);
}

.onehealth-intro__dims {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.4rem;
  margin: 0 0 0.75rem;
  padding: 0;
}

.onehealth-intro__dim {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 2.1rem;
  padding: 0.28rem 0.4rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.7);
  color: var(--oh-ink);
}

.onehealth-intro--dark .onehealth-intro__dim {
  background: rgba(15, 23, 42, 0.35);
}

.onehealth-intro__dim-mark {
  width: 0.44rem;
  height: 0.44rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.onehealth-intro__dim--physical .onehealth-intro__dim-mark {
  background: var(--oh-physical);
  box-shadow: 0 0 0 3px rgba(196, 92, 58, 0.16);
}

.onehealth-intro__dim--mental .onehealth-intro__dim-mark {
  background: var(--oh-mental);
  box-shadow: 0 0 0 3px rgba(91, 77, 179, 0.16);
}

.onehealth-intro__dim--social .onehealth-intro__dim-mark {
  background: var(--oh-social);
  box-shadow: 0 0 0 3px rgba(29, 138, 120, 0.16);
}

.onehealth-intro__align {
  padding-top: 0.65rem;
  border-top: 1px solid var(--oh-line);
  font-weight: 650;
  color: var(--oh-ink);
}

.onehealth-intro__smarttt {
  margin-top: 0.45rem;
  padding-top: 0.65rem;
  border-top: 1px solid var(--oh-line);
  color: var(--oh-ink);
  font-weight: 650;
}

@media (max-width: 520px) {
  .onehealth-intro__dims {
    grid-template-columns: 1fr;
  }

  .onehealth-intro__dim {
    justify-content: flex-start;
    padding-left: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SportClubsOneHealthIntro.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,yEAAyE;EACzE,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B;;4CAE0C;EAC1C,0CAA0C;EAC1C,gEAAgE;AAClE;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mCAAmC;EACnC,6FAA6F;EAC7F,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;AACF","sourcesContent":[".onehealth-intro {\n  --oh-ink: #1b2a32;\n  --oh-muted: #4a5d66;\n  --oh-line: rgba(27, 42, 50, 0.1);\n  --oh-wash: linear-gradient(165deg, #f4fbf8 0%, #eef6fb 52%, #f7f3ee 100%);\n  --oh-physical: #c45c3a;\n  --oh-mental: #5b4db3;\n  --oh-social: #1d8a78;\n  text-align: left;\n  border-radius: 16px;\n  padding: 0.95rem 1rem 1rem;\n  background: var(--oh-wash);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.7) inset,\n    0 10px 24px -12px rgba(27, 42, 50, 0.16);\n  border: 1px solid rgba(29, 138, 120, 0.14);\n  animation: onehealth-intro-in 0.4s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n@keyframes onehealth-intro-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .onehealth-intro {\n    animation: none;\n  }\n}\n\n.onehealth-intro--dark {\n  --oh-ink: #f4f7f8;\n  --oh-muted: rgba(226, 232, 240, 0.82);\n  --oh-line: rgba(255, 255, 255, 0.1);\n  --oh-wash: linear-gradient(165deg, rgba(29, 138, 120, 0.18) 0%, rgba(91, 77, 179, 0.12) 100%);\n  background: var(--oh-wash);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: none;\n}\n\n.onehealth-intro__eyebrow {\n  margin: 0 0 0.28rem;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--oh-social);\n}\n\n.onehealth-intro--dark .onehealth-intro__eyebrow {\n  color: #7ee0ce;\n}\n\n.onehealth-intro__title {\n  margin: 0 0 0.45rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--oh-ink);\n}\n\n.onehealth-intro__body,\n.onehealth-intro__align,\n.onehealth-intro__smarttt {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.45;\n}\n\n.onehealth-intro__body {\n  margin-bottom: 0.7rem;\n  color: var(--oh-muted);\n}\n\n.onehealth-intro__dims {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.4rem;\n  margin: 0 0 0.75rem;\n  padding: 0;\n}\n\n.onehealth-intro__dim {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 2.1rem;\n  padding: 0.28rem 0.4rem;\n  border-radius: 999px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--oh-ink);\n}\n\n.onehealth-intro--dark .onehealth-intro__dim {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.onehealth-intro__dim-mark {\n  width: 0.44rem;\n  height: 0.44rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.onehealth-intro__dim--physical .onehealth-intro__dim-mark {\n  background: var(--oh-physical);\n  box-shadow: 0 0 0 3px rgba(196, 92, 58, 0.16);\n}\n\n.onehealth-intro__dim--mental .onehealth-intro__dim-mark {\n  background: var(--oh-mental);\n  box-shadow: 0 0 0 3px rgba(91, 77, 179, 0.16);\n}\n\n.onehealth-intro__dim--social .onehealth-intro__dim-mark {\n  background: var(--oh-social);\n  box-shadow: 0 0 0 3px rgba(29, 138, 120, 0.16);\n}\n\n.onehealth-intro__align {\n  padding-top: 0.65rem;\n  border-top: 1px solid var(--oh-line);\n  font-weight: 650;\n  color: var(--oh-ink);\n}\n\n.onehealth-intro__smarttt {\n  margin-top: 0.45rem;\n  padding-top: 0.65rem;\n  border-top: 1px solid var(--oh-line);\n  color: var(--oh-ink);\n  font-weight: 650;\n}\n\n@media (max-width: 520px) {\n  .onehealth-intro__dims {\n    grid-template-columns: 1fr;\n  }\n\n  .onehealth-intro__dim {\n    justify-content: flex-start;\n    padding-left: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
